import { NoWalkScoreState } from '../types/state';
import { AnyAction } from 'redux';
import { NoWalkActionTypes } from '../actions/nowalk';

const initialState: NoWalkScoreState = {
  selectedProperty: undefined,
  selectedPeriod: undefined,
  periodOptionals: undefined,
  selectedSegment: undefined,
  segmentOptionals: undefined,
  noWalkData: undefined,
  sortOptionals: [
    { id: 0, name: 'No Sort' },
    { id: 1, name: 'Bedroom' },
    { id: 2, name: 'Segment' },
    { id: 3, name: 'From' },
    { id: 4, name: 'To' },
    { id: 5, name: 'Stickiness' },
  ],
  selectedSort: { id: 0, name: 'No Sort' },
  selectedSortType: { id: 0, name: 'Asc' },
  sortTypes: [
    { id: 0, name: 'Asc' },
    { id: 1, name: 'Desc' },
  ],
  selectedTab: 0,
  tabs: [{ id: 0, tabName: 'Segmentation' }],
};

const NoWalkScoreReducer = (
  state: NoWalkScoreState = initialState,
  action: AnyAction
) => {
  let periodOptionals = state.periodOptionals;
  //let selectedPeriod = state.periodOptionals;
  let segmentOptionals = state.periodOptionals;
  //let selectedSegment = state.periodOptionals;
  switch (action.type) {
    case NoWalkActionTypes.GET_PERIOD:
      return { ...state, periodOptionals: periodOptionals };
    case NoWalkActionTypes.GET_SEGMENTS:
      return { ...state, segmentOptionals: segmentOptionals };
    case NoWalkActionTypes.SET_PERIOD:
      return { ...state, selectedPeriod: action.payload };
    case NoWalkActionTypes.SET_TAB:
      return { ...state, selectedTab: action.payload };
    case NoWalkActionTypes.SET_SEGMENT:
      return { ...state, selectedSegment: action.payload };
    case NoWalkActionTypes.SET_SORT:
      return { ...state, selectedSort: action.payload };
    case NoWalkActionTypes.SET_SORT_TYPE:
      return { ...state, selectedSortType: action.payload };
    case NoWalkActionTypes.FETCH_ALL:
      return {
        ...state,
        selectedSegment: action.payload.segments[0],
        selectedPeriod: action.payload.periods[0],
        segmentOptionals: action.payload.segments,
        periodOptionals: action.payload.periods,
        noWalkData: action.payload.noWalkData,
      };
    default:
      return state;
  }
};

export default NoWalkScoreReducer;
